import type { ScoringChecklist } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { TemplateScoringCategories } from './TemplateScoringCategories';
import { TemplateScoringSystemPrompt } from './TemplateScoringSystemPrompt';

interface Props {
  checklist: ScoringChecklist;
  onUpdate: (checklist: ScoringChecklist) => void;
}

export type FormValues = ScoringChecklist;

export const TemplateScoringChecklistEditor = (props: Props) => {
  const { checklist, onUpdate } = props;

  const methods = useForm<FormValues>({
    defaultValues: {
      id: checklist.id,
      systemPrompt: checklist.systemPrompt,
      criteriaLabels: checklist.criteriaLabels ?? [],
      categories: checklist.categories.map((category) => ({
        id: category.id,
        description: category.description,
        criterias: category.criterias.map((criteria) => ({
          id: criteria.id,
          description: criteria.description,
          labelIds: criteria.labelIds ?? [],
        })),
      })),
    },
  });

  React.useEffect(() => {
    const subscription = methods.watch(() => {
      onUpdate(methods.getValues());
    });
    return () => subscription.unsubscribe();
  }, [methods, onUpdate]);

  return (
    <FormProvider {...methods}>
      <ChakraV3.Stack gap={4}>
        <TemplateScoringSystemPrompt />
        <TemplateScoringCategories />
      </ChakraV3.Stack>
    </FormProvider>
  );
};
